import { createFileRoute } from "@tanstack/react-router";
import { OrgSkillsPage } from "@/features/skills/org-skills-page";

export const Route = createFileRoute("/_app/settings/skills")({ component: OrgSkillsPage });
